import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import classes from "./masterSpareForm.module.css";


import {
  useAddMasterSparesVariantMutation,
  useDeleteMasterSparesVariantMutation,
  useGetMasterSparesVariantByIdQuery,
  useUpdateMasterSparesVariantMutation,
} from "../../../../services/master/masterSparesVariantApiSlice";
import { SparesVariantForm } from "../../../../component/masters/spares/sparesVariant/sparesVariantForm/SparesVariantForm";

export const MasterSpareform = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const isEditMode = Boolean(id);

  const { data, isLoading } = useGetMasterSparesVariantByIdQuery(id, {
  skip: !id,
});

  const [addVariant, addState] = useAddMasterSparesVariantMutation();
  const [updateVariant, updateState] = useUpdateMasterSparesVariantMutation();
  const [deleteVariant, deleteState] = useDeleteMasterSparesVariantMutation();

  const initialValues =  isEditMode && data
  ? data
  :  {
    brand: "",
    model: "",
    color: "",
    part_name: "",
    price: "",
    original_price: "",
    spare_image: "",
    about_this_item: [""],
    product_details: [""],
    specifications: [{ name: "", value: "" }],
    FAQs: [{ name: "", value: "" }],
  };

  const handleSubmit = async (formData) => {
    try {
      if (isEditMode) {
        await updateVariant({ id, ...formData }).unwrap();
        toast.success("Updated successfully!");
      } else {
        await addVariant(formData).unwrap();
        toast.success("Added successfully!");
      }
      navigate(-1);
    } catch (err) {
      toast.error("Failed.");
    }
  };

  const handleDelete = async () => {
    if (!window.confirm("Delete this variant?")) return;

    try {
      await deleteVariant(id).unwrap();
      toast.success("Deleted!");
      navigate(-1);
    } catch (err) {
      toast.error("Failed.");
    }
  };

  if (isEditMode && isLoading) return <div>Loading…</div>;

  return (
    <div className={classes.wrapper}>
      {" "}
      <h2 className={classes.pageTitle}>
        {" "}
        {isEditMode ? "Edit Spare Part" : "Add Spare Part"}{" "}
      </h2>
      <SparesVariantForm
        initialValues={initialValues}
        isEditMode={isEditMode}
        onSubmit={handleSubmit}
        onDelete={handleDelete}
        isSubmitting={addState.isLoading || updateState.isLoading}
        isDeleting={deleteState.isLoading}
      />
    </div>
  );
};
